import request from '@/modules/huyu-framework/backend/utils/request'

export function listAgent(query) {
  return request({ url: '/huyuAI/agent/list', method: 'get', params: query })
}

export function getAgent(id) {
  return request({ url: '/huyuAI/agent/' + id, method: 'get' })
}

export function addAgent(data) {
  return request({ url: '/huyuAI/agent', method: 'post', data })
}

export function updateAgent(data) {
  return request({ url: '/huyuAI/agent', method: 'put', data })
}

export function delAgent(ids) {
  return request({ url: '/huyuAI/agent/' + ids, method: 'delete' })
}

export function approveAgent(id) {
  return request({ url: '/huyuAI/agent/approve/' + id, method: 'put' })
}

export function rejectAgent(id, data) {
  return request({ url: '/huyuAI/agent/reject/' + id, method: 'put', data })
}

export function listModelForSelect() {
  return request({ url: '/huyuAI/model/list', method: 'get', params: { pageNum: 1, pageSize: 999 } })
}

export function listKnowledgeForSelect() {
  return request({ url: '/huyuAI/knowledge/list', method: 'get', params: { status: '0', pageSize: 999 } })
}

// RAG 策略下拉（向量检索 / 图谱检索 / 混合检索）
export function listRagStrategy() {
  return request({ url: '/huyuAI/ragStrategy/list', method: 'get' })
}
